import type { FC } from 'react';

import Pill from '@/common-components/Pill';
import type { ActivityFeedItem, ActivityFeedKind } from '@/types/stats.types';
import { timeAgo } from '@/utils/date.util';

interface ActivityFeedCardProps {
  items: ActivityFeedItem[];
}

const KIND_ICON: Record<ActivityFeedKind, string> = {
  booking: '📦',
  shoutt: '📣',
  signup: '🎓',
};

const KIND_BG: Record<ActivityFeedKind, string> = {
  booking: 'var(--color-success-bg)',
  shoutt: 'var(--color-info-bg)',
  signup: 'var(--color-brand-100)',
};

const ActivityFeedCard: FC<ActivityFeedCardProps> = ({ items }) => (
  <section className="rounded-2xl border border-[var(--color-divider)] bg-white p-6 shadow-[var(--shadow-card)]">
    <header className="mb-4 flex items-center justify-between">
      <h2 className="text-[15px] font-extrabold text-[var(--color-ink)]">Live Activity Feed</h2>
      <Pill tone="brand">Live</Pill>
    </header>

    {items.length === 0 ? (
      <p className="py-8 text-center text-[13px] text-[var(--color-ink-muted)]">
        Nothing has happened yet today.
      </p>
    ) : (
      <ul className="flex flex-col">
        {items.map((item) => (
          <li key={`${item.kind}-${item.id}`} className="flex items-start gap-3.5 py-2.5">
            <span
              className="flex h-[38px] w-[38px] shrink-0 items-center justify-center rounded-full text-sm"
              style={{ background: KIND_BG[item.kind] }}
            >
              {KIND_ICON[item.kind]}
            </span>
            <div className="min-w-0">
              <p className="truncate text-[13px] text-[var(--color-ink)]">{item.text}</p>
              <p className="text-[11.5px] text-[var(--color-ink-muted)]">
                {timeAgo(item.at)}
                {item.campusName ? ` · ${item.campusName}` : ''}
              </p>
            </div>
          </li>
        ))}
      </ul>
    )}
  </section>
);

export default ActivityFeedCard;
